module.exports = __webpack_public_path__ + "img/FGr_Infrastruktur.89507d70.svg";